import { STORAGE_KEYS } from "@/src/constants/storageKeys";
import type { PendingVerification } from "@/src/types/auth.types";
import { isBrowser } from "@/src/utils/helpers";

const COOKIE_MAX_AGE_SEC = 60 * 60 * 24 * 7;

export function setAccessTokenCookie(token: string): void {
  if (!isBrowser()) return;
  document.cookie = `${STORAGE_KEYS.AUTH_COOKIE}=${encodeURIComponent(token)}; path=/; max-age=${COOKIE_MAX_AGE_SEC}; SameSite=Lax`;
}

export function clearAccessTokenCookie(): void {
  if (!isBrowser()) return;
  document.cookie = `${STORAGE_KEYS.AUTH_COOKIE}=; path=/; max-age=0; SameSite=Lax`;
}

export function getAccessTokenFromCookie(): string | null {
  if (!isBrowser()) return null;
  const prefix = `${STORAGE_KEYS.AUTH_COOKIE}=`;
  const match = document.cookie.split("; ").find((row) => row.startsWith(prefix));
  if (!match) return null;
  return decodeURIComponent(match.slice(prefix.length));
}

export function persistPendingVerification(data: PendingVerification): void {
  if (!isBrowser()) return;
  sessionStorage.setItem(STORAGE_KEYS.PENDING_VERIFICATION, JSON.stringify(data));
}

export function getPendingVerification(): PendingVerification | null {
  if (!isBrowser()) return null;
  const raw = sessionStorage.getItem(STORAGE_KEYS.PENDING_VERIFICATION);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as PendingVerification;
  } catch {
    return null;
  }
}

export function clearPendingVerification(): void {
  if (!isBrowser()) return;
  sessionStorage.removeItem(STORAGE_KEYS.PENDING_VERIFICATION);
}

